import { render } from "./SimpleStepBar.vue?vue&type=template&id=719b24ba"
import script from "./SimpleStepBar.vue?vue&type=script&lang=ts"
export * from "./SimpleStepBar.vue?vue&type=script&lang=ts"
script.render = render

export default script